export default "__VITE_ASSET__68c7f598__"